import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.timers.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Button, PlusCircle, CrossOutedFilter, Tooltip, EyeInWindow, Snackbar, ArrowTabs, IconButton, ArrowRight } from '@gmini/ui-kit';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import * as smApi from '@gmini/sm-api-sdk';
import { useFieldArray, useForm } from 'react-hook-form';
import { useStore } from 'effector-react';
import { isNotEmpty } from '@gmini/utils';
import { useSnackbar } from 'notistack';
import { allModelsSourceItem, emptyFormCondition } from "../../constants";
import { conditionIsFilled, convertConditionsForForm, getGlobalFilterFromPersist, saveGlobalFilterToPersist, prepareSourceListForApi, prepareConditionsForSubmit, renderNodeIcon, getDependencies } from "../../utils";
import { useOnScreen } from "../../../../helpers";
import { getViewerRefs } from "../../../../classifier-editor/Common";
import { adapter } from "../../../../classifier-service/adapters";
import { useSourcesIsUpdated } from "../../hooks";
import { SourceItem } from "../SourceItem";
import { FilterCondition } from "../FilterCondition";
import { FilterPanelHeader, FilterPanelTitle, FilterPanelWrapper, CloseButton, FilterConditionList, FilterConditionListWrapper, FilterPanelFooter, Paper, FilterConditionActionPanel, FilterPanelTop, FilterPanelSubHeader, FindAnywhereButton, SourceList, SubHeader, FilterConditionListHeader, FoldIcon, UnfoldIcon, MoreButton, LinearProgress } from "./FilterPanel.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var FilterPanel = function FilterPanel(_ref) {
  var _currentEntity$source2;

  var onClose = _ref.onClose,
      searchModel = _ref.searchModel,
      nodes$ = _ref.nodes$,
      selectViewerRefs = _ref.selectViewerRefs,
      classifierId = _ref.classifierId,
      classifierVersion = _ref.classifierVersion,
      currentEntity = _ref.currentEntity,
      filterPanelService = _ref.filterPanelService,
      dependenciesWithModels$ = _ref.dependenciesWithModels$,
      seoEventHandler = _ref.seoEventHandler;
  var lastSourceElRef = useRef(null);
  var sourceListElRef = useRef(null);
  var conditionListRef = useRef(null);
  var openedFilterPanel = useStore(filterPanelService.openedFilterPanel$, {
    loc: {
      file: _effectorFileName,
      line: 84,
      column: 28
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [84, 28]"
  });
  var sourceList = useStore(filterPanelService.sources.store$, {
    loc: {
      file: _effectorFileName,
      line: 85,
      column: 21
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [85, 21]"
  });
  var initialConditionList = useStore(filterPanelService.conditions.store$, {
    loc: {
      file: _effectorFileName,
      line: 86,
      column: 31
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [86, 31]"
  });
  var propertyList = useStore(filterPanelService.filterPropertyList$, {
    loc: {
      file: _effectorFileName,
      line: 87,
      column: 23
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [87, 23]"
  });
  var propertyValuesByPropertyId = useStore(filterPanelService.filterPropertyValuesMap$, {
    loc: {
      file: _effectorFileName,
      line: 88,
      column: 37
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [88, 37]"
  });
  var nodes = useStore(nodes$, {
    loc: {
      file: _effectorFileName,
      line: 91,
      column: 16
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [91, 16]"
  });
  var searchNodes = useStore(searchModel.searchNodes$, {
    loc: {
      file: _effectorFileName,
      line: 92,
      column: 22
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [92, 22]"
  });
  var findAnywherePending = useStore(smApi.UserClassifier.findAllElementsByFilter.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 93,
      column: 30
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [93, 30]"
  });
  var fetchPropertiesPending = useStore(smApi.UserClassifier.Property.List.fetchElementProperties.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 96,
      column: 33
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [96, 33]"
  });
  var fetchElementRefsPending = useStore(smApi.UserClassifier.fetchElementRefs.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 100,
      column: 34
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [100, 34]"
  });
  var valuePending = useStore(smApi.UserClassifier.Property.List.fetchElementPropertyValues.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 103,
      column: 23
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [103, 23]"
  });
  var dependenciesWithModels = useStore(dependenciesWithModels$, {
    loc: {
      file: _effectorFileName,
      line: 107,
      column: 33
    },
    name: "FilterPanel",
    sid: "FilterPanel /src/components/FilterPanel/components/FilterPanel/FilterPanel.tsx [107, 33]"
  });

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      openedConditionList = _useState2[0],
      setOpenedConditionList = _useState2[1];

  var sourcesIsUpdated = useSourcesIsUpdated({
    sources: filterPanelService.sources
  });
  var dependencies = useMemo(function () {
    return getDependencies(dependenciesWithModels);
  }, [dependenciesWithModels]);

  var _useForm = useForm({
    defaultValues: {
      conditions: convertConditionsForForm(initialConditionList)
    }
  }),
      handleSubmit = _useForm.handleSubmit,
      control = _useForm.control,
      watch = _useForm.watch,
      reset = _useForm.reset,
      isDirty = _useForm.formState.isDirty;

  var _useFieldArray = useFieldArray({
    control: control,
    name: 'conditions'
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove,
      update = _useFieldArray.update;

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      closeSnackbar = _useSnackbar.closeSnackbar;

  var watchedConditions = watch('conditions');
  var haveUnFilledField = watchedConditions.some(function (condition) {
    return !conditionIsFilled(condition);
  });
  var haveFilledField = watchedConditions.some(conditionIsFilled);
  useEffect(function () {
    if (!openedFilterPanel.open) {
      reset({
        conditions: [emptyFormCondition]
      });
    } else if (openedFilterPanel.type === 'folder' && openedFilterPanel.open) {
      reset({
        conditions: convertConditionsForForm(initialConditionList)
      });
    }
  }, [initialConditionList, openedFilterPanel.open, openedFilterPanel.type, reset]);
  useEffect(function () {
    if (openedFilterPanel.open && openedFilterPanel.type === 'global') {
      var data = getGlobalFilterFromPersist();
      reset({
        conditions: data.properties.length ? data.properties : [emptyFormCondition]
      });
      filterPanelService.sources.set(data.sources.length ? data.sources : [allModelsSourceItem]);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [openedFilterPanel.open, openedFilterPanel.type, dependencies]);
  useEffect(function () {
    if (watchedConditions.length) {
      Promise.all(watchedConditions.map(function (_ref2) {
        var _propertyValuesByProp;

        var property = _ref2.property;

        if (!(property !== null && property !== void 0 && property.id) || (_propertyValuesByProp = propertyValuesByPropertyId[property.id]) !== null && _propertyValuesByProp !== void 0 && _propertyValuesByProp.length) {
          return;
        }

        return smApi.UserClassifier.Property.List.fetchElementPropertyValues.defaultContext({
          classifierId: classifierId,
          classifierVersion: classifierVersion,
          propertyId: property.id,
          sources: prepareSourceListForApi(sourceList, dependencies)
        });
      }));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [watchedConditions.length]);
  var hasHiddenSources = !useOnScreen({
    ref: lastSourceElRef,
    triggers: [sourceList],
    observerOptions: {
      root: sourceListElRef.current
    }
  });
  useEffect(function () {
    if (sourceList.length) {
      smApi.UserClassifier.Property.List.fetchElementProperties.defaultContext({
        classifierId: classifierId,
        classifierVersion: classifierVersion,
        sources: prepareSourceListForApi(sourceList, dependencies)
      });
    }
  }, [classifierId, classifierVersion, dependencies, sourceList, sourceList.length]);
  useEffect(function () {
    var _currentEntity$source;

    if (!(currentEntity !== null && currentEntity !== void 0 && (_currentEntity$source = currentEntity.sourceClassifiers) !== null && _currentEntity$source !== void 0 && _currentEntity$source.length)) {
      filterPanelService.closeFilterPanel();
    }
  }, [currentEntity === null || currentEntity === void 0 ? void 0 : (_currentEntity$source2 = currentEntity.sourceClassifiers) === null || _currentEntity$source2 === void 0 ? void 0 : _currentEntity$source2.length, filterPanelService]);
  var onCloseHandler = useCallback(function () {
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);
  var onRemoveFilter = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var userClassifierGroup;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            filterPanelService.sources.reset();
            filterPanelService.conditions.reset();
            reset({
              conditions: [emptyFormCondition]
            });
            searchModel === null || searchModel === void 0 ? void 0 : searchModel.resetSearchNodes();

            if (!((openedFilterPanel === null || openedFilterPanel === void 0 ? void 0 : openedFilterPanel.type) === 'folder' && openedFilterPanel.hasFilterCondition)) {
              _context.next = 10;
              break;
            }

            _context.next = 7;
            return smApi.UserClassifierGroup.removeFilter.defaultContext({
              classifierId: classifierId,
              classifierVersion: classifierVersion,
              groupId: openedFilterPanel.groupId
            });

          case 7:
            userClassifierGroup = _context.sent;
            smApi.UserClassifier.fetchFlatListItems.defaultContext({
              classifierId: userClassifierGroup.parentClassifierId,
              classifierVersion: userClassifierGroup.parentClassifierVersion
            });
            return _context.abrupt("return");

          case 10:
            saveGlobalFilterToPersist({
              properties: [emptyFormCondition],
              sources: []
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [classifierId, classifierVersion, filterPanelService.conditions, openedFilterPanel, reset, filterPanelService.sources, searchModel]);
  var onSaveFilterToFolder = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(formData) {
      var filterCondition, snackbarTextCreatedFilter, snackbarTextUpdatedFilter, hasFilterCondition, userClassifierGroup;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(openedFilterPanel.type !== 'folder')) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              filterCondition = prepareConditionsForSubmit(formData, sourceList, dependencies);

              if (filterCondition !== null && filterCondition !== void 0 && filterCondition.properties) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              onCloseHandler();
              snackbarTextCreatedFilter = "\u041D\u0430 \u043F\u0430\u043F\u043A\u0443 \u201C".concat(openedFilterPanel.groupName, "\u201D \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0444\u0438\u043B\u044C\u0442\u0440");
              snackbarTextUpdatedFilter = "\u041D\u0430 \u043F\u0430\u043F\u043A\u0435 \u201C".concat(openedFilterPanel.groupName, "\u201D \u0438\u0437\u043C\u0435\u043D\u0435\u043D \u0444\u0438\u043B\u044C\u0442\u0440");
              hasFilterCondition = !!openedFilterPanel.hasFilterCondition;

              if (filterCondition) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return");

            case 11:
              if (!hasFilterCondition) {
                _context2.next = 17;
                break;
              }

              _context2.next = 14;
              return smApi.UserClassifierGroup.updateFilter.defaultContext({
                classifierId: classifierId,
                classifierVersion: classifierVersion,
                groupId: openedFilterPanel.groupId,
                filterCondition: filterCondition
              });

            case 14:
              _context2.t0 = _context2.sent;
              _context2.next = 20;
              break;

            case 17:
              _context2.next = 19;
              return smApi.UserClassifierGroup.createFilter.defaultContext({
                classifierId: classifierId,
                classifierVersion: classifierVersion,
                groupId: openedFilterPanel.groupId,
                filterCondition: filterCondition
              });

            case 19:
              _context2.t0 = _context2.sent;

            case 20:
              userClassifierGroup = _context2.t0;
              smApi.UserClassifier.fetchFlatListItems.defaultContext({
                classifierId: userClassifierGroup.parentClassifierId,
                classifierVersion: userClassifierGroup.parentClassifierVersion
              });
              enqueueSnackbar('', {
                // eslint-disable-next-line react/display-name
                content: function content(key) {
                  return /*#__PURE__*/_jsx(Snackbar, {
                    id: key,
                    message: hasFilterCondition ? snackbarTextUpdatedFilter : snackbarTextCreatedFilter,
                    onClose: function onClose() {
                      return closeSnackbar(key);
                    }
                  });
                },
                variant: 'info'
              });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [classifierId, classifierVersion, closeSnackbar, enqueueSnackbar, dependencies, onCloseHandler, openedFilterPanel, sourceList]);
  var submitError = fields.length === 0 ? 'Необходимо добавить условия' : '';
  var conditionsIsUpdated = isDirty && haveFilledField;
  var applyError = !submitError && (conditionsIsUpdated || sourcesIsUpdated) ? '' : 'Необходимо изменить условия или область поиска';
  var findAllElements = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(formData) {
      var filterCondition, data, elements, findAllNodes, refIds, selectedViewerRefs;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler();
              filterCondition = prepareConditionsForSubmit({
                conditions: formData.conditions.filter(conditionIsFilled)
              }, sourceList, dependencies);

              if (filterCondition !== null && filterCondition !== void 0 && filterCondition.properties.length) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              searchModel.resetSearchNodes();
              _context3.next = 7;
              return smApi.UserClassifier.findAllElementsByFilter.defaultContext({
                classifierId: classifierId,
                classifierVersion: classifierVersion,
                filterCondition: filterCondition
              });

            case 7:
              data = _context3.sent;
              elements = data.elements;

              if (elements.length) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return");

            case 11:
              findAllNodes = elements.map(adapter);
              refIds = elements.flatMap(function (el) {
                return el.refIds;
              });
              searchModel === null || searchModel === void 0 ? void 0 : searchModel.setSearchNodes({
                nodes: findAllNodes.map(function (node) {
                  return {
                    node: node,
                    path: []
                  };
                }),
                filterCondition: filterCondition,
                refIds: refIds,
                type: 'filter'
              });
              _context3.next = 16;
              return Promise.all(findAllNodes.map(function (node) {
                return getViewerRefs(node, nodes);
              }));

            case 16:
              selectedViewerRefs = _context3.sent.filter(isNotEmpty).reduce(function (acc, item) {
                Object.entries(item).forEach(function (_ref6) {
                  var _ref7 = _slicedToArray(_ref6, 2),
                      key = _ref7[0],
                      value = _ref7[1];

                  var current = acc[key] || [];
                  acc[key] = [].concat(_toConsumableArray(current), _toConsumableArray(value));
                });
                return acc;
              }, {});

              if (Object.keys(selectedViewerRefs).length) {
                selectViewerRefs(selectedViewerRefs);
              }

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }(), [classifierId, classifierVersion, dependencies, nodes, searchModel, selectViewerRefs, seoEventHandler, sourceList]);

  var onChangeFilterCondition = function onChangeFilterCondition(idx, condition) {
    update(idx, condition);

    if (openedFilterPanel.open && openedFilterPanel.type === 'global') {
      saveGlobalFilterToPersist({
        properties: watchedConditions.map(function (watchedCondition, conditionIdx) {
          return conditionIdx === idx ? condition : watchedCondition;
        }),
        sources: sourceList
      });
    }
  };

  var onAddCondition = useCallback(function () {
    append({
      operator: null,
      property: null,
      value: ''
    });
    setTimeout(function () {
      if (conditionListRef.current) {
        conditionListRef.current.scrollTo({
          top: conditionListRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 0);
  }, [append]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Paper, {
      open: openedFilterPanel.open,
      children: [(fetchPropertiesPending || valuePending || findAnywherePending) && /*#__PURE__*/_jsx(LinearProgress, {}), /*#__PURE__*/_jsxs(FilterPanelWrapper, {
        children: [/*#__PURE__*/_jsxs(FilterPanelTop, {
          expanded: !openedConditionList,
          ref: sourceListElRef,
          children: [/*#__PURE__*/_jsxs(FilterPanelHeader, {
            children: [/*#__PURE__*/_jsx(FilterPanelTitle, {
              children: openedFilterPanel.type === 'folder' ? "\u0424\u0438\u043B\u044C\u0442\u0440 \u043D\u0430 \u043F\u0430\u043F\u043A\u0443 \"".concat(openedFilterPanel.groupName, "\"") : 'Фильтры'
            }), /*#__PURE__*/_jsx(CloseButton, {
              onClick: onCloseHandler,
              type: "square",
              children: /*#__PURE__*/_jsx(ArrowTabs, {
                color: "#353B60"
              })
            })]
          }), /*#__PURE__*/_jsxs(FilterPanelSubHeader, {
            children: [/*#__PURE__*/_jsx(SubHeader, {
              children: "\u041E\u0431\u043B\u0430\u0441\u0442\u044C \u043F\u043E\u0438\u0441\u043A\u0430"
            }), /*#__PURE__*/_jsx(Button, {
              onClick: onRemoveFilter,
              disabled: !fields.filter(conditionIsFilled).length,
              color: "tertiary",
              leftIcon: /*#__PURE__*/_jsx(CrossOutedFilter, {
                width: "24px",
                height: "24px"
              }),
              size: "small",
              children: openedFilterPanel.type === 'global' ? 'Очистить фильтр' : 'Убрать фильтр с папки'
            })]
          }), /*#__PURE__*/_jsxs(SourceList, {
            expanded: !openedConditionList,
            children: [sourceList.map(function (source, idx) {
              return /*#__PURE__*/_jsx(SourceItem // eslint-disable-next-line react/no-array-index-key
              , {
                icon: renderNodeIcon(source.type),
                onRemove: function onRemove() {
                  return filterPanelService.sources.remove([source]);
                },
                source: source
              }, idx);
            }), /*#__PURE__*/_jsx("div", {
              ref: lastSourceElRef
            })]
          }), openedConditionList && hasHiddenSources && /*#__PURE__*/_jsxs(MoreButton, {
            onClick: function onClick() {
              return setOpenedConditionList(false);
            },
            children: [/*#__PURE__*/_jsx("span", {
              children: "+ \u0435\u0449\u0435"
            }), " ", /*#__PURE__*/_jsx(ArrowRight, {})]
          }), /*#__PURE__*/_jsxs(FilterConditionListHeader, {
            folded: !openedConditionList,
            children: [/*#__PURE__*/_jsx(SubHeader, {
              children: "\u0423\u0441\u043B\u043E\u0432\u0438\u044F"
            }), /*#__PURE__*/_jsx(IconButton, {
              onClick: function onClick() {
                return setOpenedConditionList(function (prev) {
                  return !prev;
                });
              },
              children: openedConditionList ? /*#__PURE__*/_jsx(FoldIcon, {}) : /*#__PURE__*/_jsx(UnfoldIcon, {})
            })]
          })]
        }), /*#__PURE__*/_jsxs(FilterConditionListWrapper, {
          hide: !openedConditionList,
          children: [/*#__PURE__*/_jsx(FilterConditionList, {
            scrollableNodeProps: {
              ref: conditionListRef
            },
            children: fields.map(function (field, idx) {
              return /*#__PURE__*/_jsx(FilterCondition, {
                onRemove: function onRemove() {
                  if (openedFilterPanel.open && openedFilterPanel.type === 'global') {
                    saveGlobalFilterToPersist({
                      properties: idx === 0 ? [emptyFormCondition] : watchedConditions.filter(function (item, conditionIdx) {
                        return conditionIdx !== idx;
                      }),
                      sources: sourceList
                    });
                  }

                  if (idx === 0 && watchedConditions.length === 1) {
                    update(idx, emptyFormCondition);
                  } else {
                    remove(idx);
                  }
                },
                control: control,
                idx: idx,
                propertyList: propertyList,
                useFilterPropertyValues: filterPanelService.useFilterPropertyValues,
                sourceList: sourceList,
                classifierId: classifierId,
                classifierVersion: classifierVersion,
                onChange: onChangeFilterCondition,
                dependencies: dependencies
              }, field.id);
            })
          }), /*#__PURE__*/_jsx(FilterConditionActionPanel, {
            children: /*#__PURE__*/_jsx(Button, {
              onClick: onAddCondition,
              color: "tertiary",
              leftIcon: /*#__PURE__*/_jsx(PlusCircle, {
                width: "24px",
                height: "24px"
              }),
              disabled: haveUnFilledField,
              size: "small",
              children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"
            })
          })]
        }), /*#__PURE__*/_jsx(FilterPanelFooter, {
          children: openedFilterPanel.type === 'global' ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Tooltip, {
              title: submitError,
              styleContent: {
                marginLeft: 'auto'
              },
              children: /*#__PURE__*/_jsx(Button, {
                onClick: handleSubmit(findAllElements),
                disabled: !!submitError || !haveFilledField || findAnywherePending || fetchElementRefsPending,
                color: "info",
                size: "regular",
                children: "\u041D\u0430\u0439\u0442\u0438"
              })
            })
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FindAnywhereButton, {
              onClick: handleSubmit(findAllElements),
              color: "tertiary",
              size: "small",
              leftIcon: /*#__PURE__*/_jsx(EyeInWindow, {}),
              highlighted: (searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type) === 'filter',
              disabled: findAnywherePending || !fields.length,
              children: "\u041D\u0430\u0439\u0442\u0438 \u0432\u0435\u0437\u0434\u0435"
            }), /*#__PURE__*/_jsx(Tooltip, {
              title: applyError,
              children: /*#__PURE__*/_jsx(Button, {
                onClick: handleSubmit(onSaveFilterToFolder),
                disabled: !!applyError,
                color: "info",
                size: "regular",
                children: "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u0438 \u0437\u0430\u043A\u0440\u044B\u0442\u044C"
              })
            })]
          })
        })]
      })]
    })
  });
};